// src/components/LayoutHandler.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AnimatedOutlet from "./Common/AnimatedOutlet/AnimatedOutlet";
import MobileRedirectionHeader from "./MobileRedirectionComponents/Header/Header";
import MobileRedirectionFooter from "./MobileRedirectionComponents/Footer/Footer";

import { Col, Row } from "react-bootstrap";
import apple from "../../src/assets/img/apple_head.png";
import robot from "../../src/assets/img/Vector.png";

import { ToastContainer } from "react-toastify";

const LayoutHandler = () => {
  const [authType, setAuthType] = useState("none"); // 'professional' | 'client' | 'none'
  const [showFooter, setShowFooter] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Watch authentication state
  useEffect(() => {
    const checkAuth = () => {
      const professionalToken =
        JSON.parse(localStorage.getItem("professionalData"))?.profileSteps === 4
          ? true
          : false;
      const clientToken =
        JSON.parse(localStorage.getItem("clientData"))?.profileSteps === 2
          ? true
          : false;

      if (professionalToken) setAuthType("professional");
      else if (clientToken) setAuthType("client");
      else setAuthType("none");
   //   //console.log("Auth Type checked:", authType);
    };

    checkAuth();
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  // React to logout / 401 session expiry (axios interceptor dispatches "logout")
  useEffect(() => {
    const handleLogoutEvent = () => {
      setAuthType("none");
      const path = location.pathname;
      const stayOnAuthScreen =
        path === "/login" || path === "/get-started";
      if (!stayOnAuthScreen) {
        navigate("/login", { replace: true });
      }
    };

    window.addEventListener("logout", handleLogoutEvent);
    return () => window.removeEventListener("logout", handleLogoutEvent);
  }, [navigate, location.pathname]);

  // Handle custom footer toggle event
  useEffect(() => {
    const handleToggleFooter = (e) => {
      setShowFooter(e.detail); // e.detail = true or false
    };

    window.addEventListener("toggleFooter", handleToggleFooter);
    return () => window.removeEventListener("toggleFooter", handleToggleFooter);
  }, []);

  
  return (
    <>
      {/* <div className="topbar">
        <div className="nav-width topbar">
          <div className="nav-topbar-container topbar-width custom_container">
            <Row className="align-items-center justify-content-between">
              <Col>
                <p className="mb-0 text" style={{ fontSize: 11 }}>
                  Download the SimpleRenovate app on iOS now!{" "}
                  <img
                    src={apple}
                    alt="Download App"
                    className="topbar-logo"
                    style={{
                      height: "20px",
                       margin: "0 15px 0 6px",
                      marginLeft: "6px",
                      paddingRight: 20,
                      borderRight: "1px solid #fff",
                    }}
                  />
                  Android coming soon!{" "}
                  <img
                    src={robot}
                    alt="Download App"
                    className="topbar-logo"
                    style={{ height: "20px", marginLeft: 6 }}
                  />
                </p>
              </Col>
            </Row>
          </div>
        </div>
      </div> */}

      <ToastContainer position="top-right" autoClose={3000} />

      {/* HEADER */}
      {authType === "professional" && <MobileRedirectionHeader />}
      {authType === "client" && <MobileRedirectionHeader />}
      {authType === "none" && <MobileRedirectionHeader />}

      {/* MAIN CONTENT */}
      {/* <div className="min-height-screen"> */}
      <AnimatedOutlet />
      {/* </div> */}

      {/* FOOTER */}
      {showFooter && (
        <>
          {/* {authType === "professional" && <MobileRedirectionFooter />}
          {authType === "client" && <MobileRedirectionFooter />}
          {authType === "none" && <MobileRedirectionFooter />} */}
        </>
      )}
    </>
  );
};

export default LayoutHandler;
